import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { ButtonCoreComponent } from '../button-core/button-core.component';

import '@diekeure/dcr-components/dcr-badge.js';
import '@diekeure/dcr-components/dcr-focus-ring.js';
import '@diekeure/dcr-components/dcr-state-layer.js';

@Component({
  standalone: false,
  selector: 'campus-tonal-button, [tonal-button]',
  templateUrl: './tonal-button.component.html',
  styleUrls: ['./tonal-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TonalButtonComponent extends ButtonCoreComponent {
  @HostBinding('class')
  defaultClasses = [
    ...this.coreClasses,
    'tonal-button',

    'inline-flex',
    'w-fit',

    'corner-full',
    'border-0',
    'outline-none',

    'disabled:bg-on-surface',
    'disabled:bg-opacity-press',
    'disabled:on-surface',
    'disabled:border-none',

    'transition-elevation',
  ];

  @HostBinding('attr.data-color')
  @Input()
  color:
    | 'primary'
    | 'secondary'
    | 'tertiary'
    | 'stage.draft'
    | 'stage.needs-review'
    | 'stage.queue'
    | 'stage.ready-for-pub'
    | 'stage.published'
    | 'stage.need-changes'
    | 'stage.error'
    | 'stage.changed' = 'primary';

  @HostBinding('attr.data-has-leading-icon')
  @Input()
  leadingIcon: string;

  @HostBinding('attr.data-has-trailing-icon')
  @Input()
  trailingIcon: string;
}
